var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "63658241-7DF1-4108-ADF4-CA9CCB834EDC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SWX_reference",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coupons_offers_categorylanding_v3_Desktop",
    transform: "translate(-1299.000000, -538.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-nav",
    transform: "translate(83.000000, -437.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards-/-Horizontal-/-Sample-Set-/-Medium-/-Image-6-Column",
    transform: "translate(376.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "print-icon",
    transform: "translate(840.000000, 975.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Communication&Connectivity/ContactInfo/FaxNumber/40",
    transform: "translate(1.250000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.58235719,18.5716343 L16.2480155,18.5716343 L16.2480155,11.4283657 L1.58235719,11.4283657 L1.58235719,18.5716343 Z M4.51637571,10 L13.3154751,10 L13.3154751,1.42836573 L4.51637571,1.42836573 L4.51637571,10 Z M14.7817453,10 L14.7817453,0 L3.0486274,0 L3.0486274,10 L1.58235719,10 C0.325754951,10 0,10.3669742 0,11.4283657 L0,18.5716343 C0,19.5708956 0.325754951,20 1.58235719,20 L16.2480155,20 C17.0535773,20 17.7142857,19.3563715 17.7142857,18.5716343 L17.7142857,11.4283657 C17.7142857,10.6436285 17.0535773,10 16.2480155,10 L14.7817453,10 Z M5.98264592,8.57163427 L11.8492049,8.57163427 L11.8492049,7.14326854 L5.98264592,7.14326854 L5.98264592,8.57163427 Z M5.98264592,5.71490281 L11.8492049,5.71490281 L11.8492049,4.28653708 L5.98264592,4.28653708 L5.98264592,5.71490281 Z M5.98264592,15.7134629 L11.8492049,15.7134629 L11.8492049,14.2850972 L5.98264592,14.2850972 L5.98264592,15.7134629 Z M4.51637571,17.1432685 L13.3154751,17.1432685 L13.3154751,12.8567315 L4.51637571,12.8567315 L4.51637571,17.1432685 Z",
    id: "ContactInfoFaxNumber"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print-icon.1fe142d584e9eeb1dcc4392cd106b003.svg";
export { ForwardRef as ReactComponent };